import {AppointmentBooked} from 'domain/usecases';
import {DateFormatEnum} from 'presentation/constants';
import {formatAddress, formatDateString} from 'presentation/utils';
import {validatePhoneNumbers} from '../validatePhoneNumbers';
import {ParsedOdontoAppointment} from './types';

export const parseOdontoAppointments = (
	agendamentosOdonto: AppointmentBooked[],
): ParsedOdontoAppointment[] =>
	agendamentosOdonto.map(item => ({
		bookingNumber: item.nuConsulta?.toString(),
		specialtyCode: item.cdEspecialidade?.toString(),
		subSpecialtyCode: item.cdSubEspecialidade?.toString(),
		specialtyName: item.dsSubEspecialidade
			? `${item.dsEspecialidade} - ${item.dsSubEspecialidade}`
			: item.dsEspecialidade,
		clinicName: item.nmPrestadorJuridico,
		providerName: item.nmPrestadorFisico,
		bookingType: item.tipoConsulta,
		formattedAddress: formatAddress({
			type: item.tipoLogradouro,
			state: item.cdUf,
			city: item.nmCidade,
			number: item.numero?.toString(),
			address: item.logradouro,
			complement: item.complemento,
			district: item.bairro,
			reference: item.pontoReferencia,
		}),
		date: formatDateString(item.dtConsulta, DateFormatEnum.DATE_FORMAT_2, 'P HH:mm'),
		dateOnly: formatDateString(
			item.dtConsulta,
			DateFormatEnum.DATE_FORMAT_2,
			DateFormatEnum.DATE_FORMAT_8,
		),
		hour: formatDateString(item.dtConsulta, DateFormatEnum.DATE_FORMAT_2, 'HH:mm'),
		formattedDateWithWeekday: formatDateString(
			item.dtConsulta,
			DateFormatEnum.DATE_FORMAT_2,
			'EEEE, dd/MM/yy',
		),
		telehealthUrl: null,
		protocolNumber: item.nuProtocolo,
		isConfirmed: item.confirmado === 'Sim',
		phoneNumbers: validatePhoneNumbers(item.nuTelefone),
		recommendations: item.dsRecomendacoes,
		email: item.email,
		phone: item.telefone,
	}));
